import { combineReducers } from "redux";
import { combineEpics } from "redux-observable";

import authReducer from "./auth/reducer";
import authEpic from "./auth/epic";
import profileReducer from "./profile/reducer";
import profileEpic from "./profile/epic";
import onboardingReducer from "./onboarding/reducer";
import onboardingEpic from "./onboarding/epic";

export const reducer = combineReducers({
  auth: authReducer,
  onboarding: onboardingReducer,
  profile: profileReducer
});

export const epic = combineEpics(authEpic, onboardingEpic, profileEpic);



// WEBPACK FOOTER //
// ./src/modules/user/index.js